"use strict";

exports.__esModule = true;
exports.default = exports.Basic = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    height: 5px;\n    z-index: 1;\n    margin-left: 5px;\n    background-color: ", ";\n    cursor: pointer;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    margin-left: 0;\n\n    width: 16px;\n    height: 16px;\n    background-color: ", ";\n    border: 1px solid #ACC2D3;\n    border-radius: 50%;\n\n    color: transparent;\n    text-align: center;\n    cursor: pointer;\n    z-index: 2;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    height: 5px;\n    border-radius: 5px;\n    background-color: ", ";\n    box-shadow: 0 1px 7px -1px rgba(0,0,0,0.1), inset 0 1px 3px 0 #ACC2D3;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette;
var Basic = {
  railBar: (0, _styledComponents.css)(_templateObject(), KineduPalette.shadeMediumLight),
  handle: (0, _styledComponents.css)(_templateObject2(), KineduPalette.shadeLighter),
  track: (0, _styledComponents.css)(_templateObject3(), KineduPalette.kinedu),
  input: (0, _styledComponents.css)(_templateObject4())
};
exports.Basic = Basic;
var RangerThemes = {
  Basic: Basic
};
var _default = RangerThemes;
exports.default = _default;